import { __decorate } from "tslib";
import Modal from "@/components/Modal.vue";
import CreateUserDialog from "@/components/Modals/CreateUserDialog.vue";
import UserTariffDialog from "@/components/Modals/UserTariffDialog.vue";
import WhiteBox from "@/components/WhiteBox.vue";
import UserList from "@/types/User/UserList";
import moment from "moment";
import { Component, Vue } from "vue-property-decorator";
import ClosedReportDate from "@/components/ClosedReportDate.vue";
import DatePickerTextbox from "@/components/DatePickerTextbox.vue";
import ImpersonationButton from "@/components/ImpersonationButton.vue";
import BenefitsModal from "@/components/Modals/Benefits/BenefitsModal.vue";
import User from "@/types/User/User";
let EmployeesEditor = class EmployeesEditor extends Vue {
    //returns if the employee is currenly hired
    isCurrentEmployee(employee) {
        return (moment(new Date()) <= moment(employee.endOfEmployment) ||
            employee.endOfEmployment === null);
    }
    //filter the employees list based on current employee
    filterCurrentEmployees() {
        if (this.$data.onlyCurrentEmployees === true) {
            this.$data.filteredEmployees = this.$data.employees.filter((employee) => {
                return this.isCurrentEmployee(employee);
            });
        }
        else {
            this.$data.filteredEmployees = this.$data.employees;
        }
    }
    getLevelPercentage(hoursLeft, levelName) {
        if (this.$data.levels.length === 0) {
            return 0;
        }
        const levelToCheck = this.$data.levels.find((level) => level.name === levelName);
        if (!levelToCheck) {
            return 0;
        }
        if (hoursLeft < 0) {
            return 100;
        }
        return hoursLeft >= levelToCheck.hours ? 0 : Math.floor(((levelToCheck.hours - hoursLeft) / levelToCheck.hours) * 100);
    }
    //send api call to remove the user
    deleteEmployee() {
        this.$store
            .dispatch("deleteEmployeeAsync", this.$data.selectedEmployee)
            .then((response) => {
            this.loadEmployees();
            this.$data.showDeleteEmployeeDialog = false;
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components/EmployeesEditor.vue - deleteEmployee");
        });
    }
    shortDate(date) {
        return window.dateHandler.formatDateNoTime(date);
    }
    //shows the external tariff modal to add tariffs for a employee
    showTariffModal(userItem) {
        this.$data.selectedEmployee = userItem; // the refence used for the user in the component gets updated
        this.$data.showUserTariffDialog = true;
    }
    //shows the edit modal
    showEditModal(item) {
        this.$data.selectedEmployee = item; //sets the selected user before opening the edit modal
        this.$data.modals.editEmployee = true;
    }
    updateCreateUser(value) {
        //recieve the event from the child to determine if we should close the modal (part of the "createUserDialog")
        this.$data.showCreateUserDialog = value;
    }
    updateEditEmployee(value) {
        //recieve the event from the child to determine if we should close the modal (part of the "editEmployeeDialog")
        this.$data.modals.editEmployee = value;
    }
    closeAddModal() {
        this.$data.selectedUserToAdd = null;
        this.$data.selectedTeamToAddTo = null;
        this.$data.userList = null;
        this.$data.teamList = null;
        this.$data.modals.addemployeeModal = false;
    }
    loadEmployees() {
        this.$data.filteredEmployees = null;
        this.$store
            .dispatch("adminGetAllEmployees")
            .then((result) => {
            this.$data.employees = result.data;
            this.filterCurrentEmployees();
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components/EmployeesEditor.vue - loadEmployees");
        });
    }
    loadUsers() {
        console.log("loading users");
        this.$data.loadingUsers = true;
        this.$store
            .dispatch("getAllUsers")
            .then((result) => {
            this.$data.userList = new UserList(result.data);
            this.$data.loadingUsers = false;
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components/EmployeesEditor.vue - loadUsers");
        });
    }
    showAddModal() {
        this.loadUsers();
        //clear the selected data before we show the dialog
        (this.$data.selectedUserToAdd = null),
            (this.$data.createEmployeeDates = { from: null, to: null });
        //show create dialog
        this.$data.modals.addemployeeModal = true;
    }
    addEmployee() {
        //assign the userID and email from the selected user to the
        this.$data.createEmployee.userId = this.$data.selectedUserToAdd.id;
        this.$data.createEmployee.email = this.$data.selectedUserToAdd.email;
        this.$store
            .dispatch("createEmployeeAsync", this.$data.createEmployee)
            .then((result) => {
            this.loadEmployees();
            this.$data.modals.addemployeeModal = false;
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components/EmployeeEditor.vue -> addEmployee");
        });
    }
    updateEmployee() {
        this.$store
            .dispatch("updateEmployee", this.$data.selectedEmployee)
            .then((result) => {
            this.$store.dispatch("ToastMessage", {
                type: "any",
                message: "The employee " +
                    this.$data.selectedEmployee.firstName +
                    " " +
                    this.$data.selectedEmployee.lastName +
                    " has been updated",
            });
            this.$data.modals.editEmployee = false;
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components/IntersEditor.vue -> updateEmployee");
            this.$data.modals.editEmployee = false;
        });
    }
    impersonateUser(userItem) {
        //Retrieve the user object
        this.$store
            .dispatch("getUser", userItem.userId)
            .then((result) => {
            const impersonateUser = new User(userItem);
            this.$store.dispatch("impersonateUser", impersonateUser);
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components/IntersEditor.vue -> impersonateUser");
        });
    }
};
EmployeesEditor = __decorate([
    Component({
        props: ["impUsers"],
        data() {
            return {
                levels: [],
                theme: this.$store.getters.getTheme,
                filter: "",
                employees: null,
                filteredEmployees: null,
                modals: { addemployeeModal: false, editEmployee: false },
                sortbyValue: "email",
                onlyCurrentEmployees: true,
                showBenefitsModal: false,
                selectedEmployee: null,
                userList: null,
                teamList: null,
                loadingUsers: false,
                loadingTeams: false,
                selectedUserToAdd: null,
                selectedTeamToAddTo: null,
                showCreateUserDialog: false,
                showUserTariffDialog: false,
                showDeleteEmployeeDialog: false,
                showLevelBenefitDialog: false,
                showTeamManagerBenefitDialog: false,
                showFixedBenefitDialog: false,
                createEmployeeDates: { from: null, to: null },
                createEmployee: {
                    employmentNumber: null,
                    email: "",
                    employmentDate: window.dateHandler.convertToUTCTime(new Date()),
                    userId: "",
                },
                employeeHeaders: [
                    { text: "Name", value: "email", align: "start", divider: true },
                    {
                        text: "Closed Reports",
                        value: "closedReportsDate",
                        align: "center",
                        divider: true,
                    },
                    {
                        text: "Level up",
                        value: "levelHoursLeft",
                        align: "center",
                        divider: true,
                    },
                    {
                        text: "Impersonate",
                        value: "impersonate",
                        sortable: false,
                        align: "center",
                    },
                    {
                        text: "Benefits",
                        value: "employmentNumber",
                        align: "center",
                        sortable: false,
                    },
                    { text: "Tariffs", value: "tariffs", sortable: false, align: "center" },
                    { text: "Edit", value: "edit", sortable: false, align: "center" },
                    { text: "", value: "delete", sortable: false, align: "center" },
                ],
            };
        },
        async created() {
            this.loadEmployees();
            this.$data.levels = (await this.$store.dispatch("loadGlobalLevelsAsnyc")).data;
        },
        components: {
            ClosedReportDate,
            WhiteBox,
            Modal,
            CreateUserDialog,
            UserTariffDialog,
            ImpersonationButton,
            DatePickerTextbox,
            BenefitsModal,
        },
    })
], EmployeesEditor);
export default EmployeesEditor;
